import { Component } from "react";
import { Text } from "@chakra-ui/react";
import bookingConfirmed from "../../assets/images/booking-success.png";
import "./BookingConfirmed.css";
import { Mixpanel } from "../../Services/MixPanel";

interface BookingConfirmedProps {
  onClick?: () => void;
  bookingText?: string;
  bookingId?: string;
  inspectionDate?: string;
  inspectionTime?: string;
  onCountdownComplete?: () => void; // Function to call after countdown
}

interface BookingConfirmedState {
  countdown: number;
}

class BookingConfirmed extends Component<
  BookingConfirmedProps,
  BookingConfirmedState
> {
  timerId: NodeJS.Timeout | null = null;

  constructor(props: BookingConfirmedProps) {
    super(props);
    this.state = {
      countdown: 5, // Start countdown from 5 seconds
    };
  }

  componentDidMount() {
    this.timerId = setInterval(() => {
      this.setState(
        (prevState) => ({ countdown: prevState.countdown - 1 }),
        () => {
          if (this.state.countdown <= 0) {
            this.clearTimer();
            if (this.props.onCountdownComplete) {
              this.props.onCountdownComplete();
            }
          }
        }
      );
    }, 1000);

    Mixpanel.track("Booking Confirmed", {
      estimateId: this.props.bookingId,
      inspectionTime: this.props.inspectionTime,
      message: "Booking successfully confirmed and redirected.",
      inspectionDate: this.props.inspectionDate
    });
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  clearTimer() {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }

  render() {
    const { onClick = () => {}, bookingText = "Booking Confirmed" } =
      this.props;
    const { countdown } = this.state;
    const greetMessage = `Thank you for choosing Flow Autobody. We look forward to seeing you soon!`;
    const confirmationMessage = `We've sent this confirmation to your email address. Please check your inbox for reference.`;

    return (
      <div className="container">
        <div className="bookingContainerTopBox box">
          <Text className="redirecting-text">
            {`You will be redirected to the booking tab in ${countdown} second${
              countdown !== 1 ? "s" : ""
            }`}
          </Text>
          <Text className="hide-content">{greetMessage}</Text>
        </div>
        <div className="center box">
          <img
            src={bookingConfirmed}
            alt="Confirmation success"
            className="booking-confirmed-image"
          />
          <Text className="booking-heading">{bookingText}</Text>
          <Text className="text">{greetMessage}</Text>
          <button className="go-to-home" onClick={onClick}>
            Home
          </button>
        </div>

        <div className="bottom box">
          <Text className="bottom-text">{confirmationMessage}</Text>
        </div>
      </div>
    );
  }
}

export default BookingConfirmed;
